// src/context/api.js
export const BASE_URL = 'https://oxfordstudycenter.online';
